import React from 'react';
import { Icon, Row, Text, Accordion } from '../../../../../../../components/common';
import { withFirebase } from '../../../../../../../hoc';
import OrderCallHistory from '../../../../../../../components/sections/OrderCallHistory';

const CallAndChatHistoryLegacy = ({ callAndChatHistoryAllowed, orderId, firebase, isWhatsapp }) => {
    if (!callAndChatHistoryAllowed) return null;
    
    return (<Accordion
        title={<Row align='center' gap={15}>
            <Icon name='phone-rigning' color='#1FA02E' size={16} />
            <Text strong text='Historial de Llamadas y Chat' />
        </Row>}
        iconOpened='chebron_down'
        iconClosed='chebron_up'
        iconSize={10}
        styleHeader={{ borderRadius: 8 }}
        background='#f4f4f4'
        closedBackground='white'
        style={{ boxShadow: '0px 4px 12px 0px #00000014', margin: '15px 0px 15px 0px', borderRadius: 8 }}
    >
        <OrderCallHistory
            callHistoryType='shopper_calls'
            orderId={orderId}
            firebase={firebase}
            isWhatsapp={isWhatsapp}
        />
    </Accordion>);
};

export default withFirebase(CallAndChatHistoryLegacy);
